import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const EmptyState = ({ title, message, buttonText, routerPath }) => {
  const navigate = useNavigate();
  return (
    <Box
      width="100%"
      heigth="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={1}
    >
      <Stack direction="column">
        <Typography fontWeight="bold" fontSize="16px" textAlign="center">
          {title}
        </Typography>
        <Typography fontSize="14px" textAlign="center">
          {message}
        </Typography>
      </Stack>
      <Button
        variant="text"
        onClick={() => navigate(routerPath)}
        sx={{ textTransform: "none", textDecoration: "underline" }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default EmptyState;
